import type { UserLicenseResponse } from '../../services/api/types.gen';

/** What the confirmation is armed against. One or the other, never both. */
export type PendingDelete =
  | { kind: 'license'; licenseId: string; label: string }
  | {
      kind: 'document';
      licenseId: string;
      documentId: string;
      label: string;
    };

/**
 * What the confirmation should actually act on, given the list as it stands now.
 *
 * The dialog can outlive its target: an action completing elsewhere reloads the
 * list and the row goes. Acting on the stale id would ask the server to delete
 * something already gone and surface the 404 as a failure the operator can do
 * nothing about, so a vanished target resolves to `null` and the dialog just
 * closes.
 */
export const resolveDeleteTarget = (
  licenses: UserLicenseResponse[],
  pending: PendingDelete
):
  | { kind: 'license'; license: UserLicenseResponse }
  | { kind: 'document'; licenseId: string; documentId: string }
  | null => {
  const parent = licenses.find(row => row.id === pending.licenseId);
  if (!parent) return null;
  if (pending.kind === 'license') return { kind: 'license', license: parent };
  const stillAttached = (parent.documents ?? []).some(
    document => document.id === pending.documentId
  );
  if (!stillAttached) return null;
  return {
    kind: 'document',
    licenseId: pending.licenseId,
    documentId: pending.documentId,
  };
};
